import { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import i18n, { tulkaLanguages, setLanguage, getLang } from '../i18n';
import logo from '../images/tulka_logo.svg';
import heroLogo from '../images/hero_logo_horizontal.png';
import { RoundButton } from '../components/Buttons';
import SelectLanguages from '../components/SelectLanguages';
import { getSelfRegistrationRoutes, translateSelfRegistrationPath } from '../utils/redirectUtils';
import { isHeroBrandEnabled } from '../utils/heroBrandUtils';

import ThemeContext from '../contexts/ThemeContext';


const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px;
  ${({ background }) => background && `background: ${background};`}
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Logo = styled.div`
  width: 105px;
  img {
    display: block;
    width: 100%;
    heigh: auto;
  }
  @media (max-width: 768px) {
    width: 60px;
    min-width: 60px;
  }
`;

const ButtonsContent = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 768px) {
    gap: 0;
    justify-content: end;
    button {
      font-size: 12px;
      padding: 0 6px;
      margin-top: 3px;
    }
  }
`;

const StyledButton = styled(RoundButton)`
  white-space: nowrap
`;

const SwitchLangBlock = styled.div`
  width: 120px;
`;

const SignUpButton = styled(StyledButton)`
  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = () => {
  const history = useHistory();
  const location = useLocation();
  const { colors } = useContext(ThemeContext);
  const [selectedLanguage, setSelectedLanguage] = useState(getLang());
  const isHero = isHeroBrandEnabled();

  // A localized self-registration path sets the language on entry, so the switcher has
  // to follow the event rather than only its own clicks.
  useEffect(() => {
    const func = () => {
      setSelectedLanguage(getLang());
    };
    document.addEventListener('changeLang', func);
    return () => {
      document.removeEventListener('changeLang', func);
    };
  }, []);

  const handleSwithcLanguage = (langObj) => {
    if (getLang() !== langObj.value) {
      setSelectedLanguage(langObj.value);
      setLanguage(langObj.value, true);
      document.dispatchEvent(new CustomEvent('changeLang', {
        detail: {
          lang: langObj.value
        }
      }));
      // On a self-registration page the URL is localized too, so keep it in step. Only
      // the pathname changes — the verification page reads its `token` from the query
      // string, so replacing the whole location would break a reload of that URL.
      const translatedPath = translateSelfRegistrationPath(location.pathname, langObj.value);
      if (translatedPath && translatedPath !== location.pathname) {
        history.replace({
          pathname: translatedPath,
          search: location.search,
          hash: location.hash,
          state: location.state
        });
      }
    }
  };

  return (
    <HeaderContainer background={colors.selfRegistrationHeaderBackground}>
      <Logo>
        <img src={isHero ? heroLogo : logo} alt={isHero ? 'Herotolk' : 'Túlka'} />
      </Logo>
      <ButtonsContent>
        <StyledButton
          data-test='selfRegistrationlogInBtn'
          fontSize={14}
          height={37}
          padding='32'
          radius={32}
          hideBorder={true}
          nowrap={true}
          lineHeight={21}
          label={i18n('log_in')}
          onClick={() => {
            history.push('/login');
          }}
          smallButton={true}
          darkButton={false}
        />
        <SignUpButton
          data-test='selfRegistrationSignUpBtn'
          label={i18n('sign_up')}
          onClick={() => {
            history.push(getSelfRegistrationRoutes().email);
          }}
          fontSize={14}
          height={37}
          padding='32'
          radius={32}
          nowrap={true}
          lineHeight={21}

          smallButton={true}
          darkButton={true}
        />
        <SwitchLangBlock>
          <SelectLanguages
            activeColor={colors.tulkaMainColor}
            hoverColor={colors.tulkaMainColor}
            backgroundHoverColor = '#DFFFFE'
            selectedLanguage={selectedLanguage}
            avaliableLangs={tulkaLanguages.map(lang => ({key: lang, lable: lang}))}
            handleSwithcLanguage={handleSwithcLanguage}
          />
        </SwitchLangBlock>
      </ButtonsContent>
    </HeaderContainer>
  );
};


export default Header;
